import React from 'react';
import { Box, Typography, Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { HiChevronRight } from 'react-icons/hi';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface AdminV2BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const AdminV2Breadcrumbs: React.FC<AdminV2BreadcrumbsProps> = ({ items }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs
        separator={<HiChevronRight size={14} />}
        aria-label="breadcrumb"
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast || !item.path) {
            return (
              <Typography
                key={index}
                variant="body2"
                color="text.primary"
                fontWeight={isLast ? 600 : 400}
              >
                {item.label}
              </Typography>
            );
          }

          return (
            <RouterLink
              key={index}
              to={item.path}
              style={{
                textDecoration: 'none',
                color: 'var(--color-primary, #667eea)',
                fontSize: '0.875rem',
              }}
            >
              {item.label}
            </RouterLink>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default AdminV2Breadcrumbs;
